import { computed, signal } from "@angular/core";

export interface Admin {
  name: {
    firstName: string;
    lastName: string;
  };
}

interface UserStateModel {
  user: Admin;
}

export class UserState {
  private static readonly state = signal<UserStateModel>({ user: {} as Admin });

  public static readonly user = computed(() => UserState.state().user);

  public static patchUser(user: Admin): void {
    this.state.update(s => ({ ...s, user: { ...s.user, ...user } }));
  }
}
